import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ProjectMemberService from "../../controller/ProjectMemberController/ProjectMemberController";
import { handleChange, handleSubmit } from "../../controller/ProjectMemberController/CreateProjectMemberController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";

function CreateProjectMember({ member, onClose, onSuccess, ProjectList }) {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({ ID: 0, ProjectID: 0, UserID: 0 });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [UserList, setUserList] = useState([]);
    const { theme } = useContext(ThemeContext);
    const accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";


    const fetchUsers = async (projectID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const list = await ProjectMemberService.GetAllProjectUsers(redirectCallback, projectID);
            debugger;
            setUserList(list);
        } catch (error) {
            console.error('Error fetching Asset Categories:', error);
        }
    };
    const handleProjectChange = (event) => {
        const { value } = event.target;
        const projectId = event.target.value;
        debugger;
        const selectedCustomer = ProjectList.find(project => project.ID === parseInt(projectId));
        setFormData({
            ...formData,
            ProjectID: value,
            UserID: 0, // Reset Site

        });
        fetchUsers(value);

    };
    useEffect(() => {
        if (member) {
            setFormData({
                ID: member.ID,
                ProjectID: member.ProjectID,
                UserID: member.UserID
            });
            setErrors({});
        } else {
            setFormData({ ID: 0, ProjectID: 0, UserID: 0 }); // Clear form data when switching to add mode
            setErrors({});
        }
    }, [member, ProjectList]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit = (event) => {
        event.preventDefault();
        if (member) {
            formData.ID = member.ID;
        } else {
            formData.ID = 0;
        }
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const redirectUserList = () => {
            navigate('/AdministrationSetting?saved=true');
        };

        handleSubmit(event, formData, setFormData, setErrors, () => {
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
        }, () => {
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
        });
    };

    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade" id="projectMemberModal" tabIndex="-1" aria-labelledby="projectMemberModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="assetSubCategoriesModalLabel">{member ? "Edit Member" : "Add Member"}</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="ProjectID" className="col-sm-2 col-form-label">Select Project:</label>
                                    <div className="col-sm-4">
                                        <select name="ProjectID" className='form-control' value={formData.ProjectID} onChange={handleProjectChange}>
                                            <option value="0">Select Project</option>
                                            {ProjectList.map((project) => (
                                                <option key={project.ID} value={project.ID}>
                                                    {project.ProjectName}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.ProjectID && <div style={{ color: 'red' }}>{errors.ProjectID}</div>}
                                    </div>
                                    <label htmlFor="SubCategoryName" className="col-sm-2 col-form-label">Select User:</label>
                                    <div className="col-sm-4">
                                        <select name="UserID" className='form-control' value={formData.UserID} onChange={handleFieldChange}>
                                            <option value="0">Select User</option>
                                            {UserList.map((user) => (
                                                <option key={user.UserID} value={user.UserID}>
                                                    {user.DisplayName}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.UserID && <div style={{ color: 'red' }}>{errors.UserID}</div>}
                                    </div>
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">
                                <i className="icofont-save" aria-hidden="true"> {member ? " Update" : " Save"}</i>
                                </button>
                                <button className="btn btn-secondary" type="button" data-dismiss="modal" aria-label="Close">
                                <i className="icofont-close" aria-hidden="true"> Close</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default CreateProjectMember;
